// extracted by mini-css-extract-plugin
export var pageTitleContainer = "pageTitle-module--pageTitleContainer--1wsXX";
export var pageTitle = "pageTitle-module--page-Title--KPoT_";
export var pageTitleBg = "pageTitle-module--pageTitleBg--15Zii";